import { Component } from '@angular/core';

@Component({
  selector: 'fgb-quiz-layout-page',
  templateUrl: './quiz-layout-page.component.html',
  styleUrl: './quiz-layout-page.component.scss',
})
export class QuizLayoutPageComponent {}
